import { useState, useEffect } from 'react';

export default function OfertaIrresistible() {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const [spotsLeft] = useState(12);
  const totalSpots = 100;
  const progressPercentage = ((totalSpots - spotsLeft) / totalSpots) * 100;

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      
      const difference = midnight.getTime() - now.getTime();
      
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);
      
      setTimeLeft({ hours, minutes, seconds });
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleComprar = () => {
    alert('¡Gracias por tu interés! El sistema de pago se integrará próximamente.');
  };

  const isLastMinute = timeLeft.hours === 0 && timeLeft.minutes === 0;

  return (
    <section
      id="oferta-section"
      className="relative min-h-screen w-full flex items-center justify-center overflow-hidden py-12 sm:py-20"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=minimalist%20modern%20workspace%20with%20sleek%20laptop%20displaying%20professional%20dashboard%20interface%20on%20clean%20white%20desk%2C%20soft%20natural%20lighting%20from%20side%2C%20simple%20elegant%20setup%20with%20coffee%20cup%20and%20notebook%2C%20blurred%20background%20with%20warm%20tones%2C%20professional%20business%20environment%20with%20sophisticated%20aesthetic%20and%20organized%20workspace&width=1920&height=1080&seq=oferta-workspace-bg-001&orientation=landscape')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/30 to-black/55"></div>

      <div className="relative z-10 text-center w-full max-w-2xl mx-auto px-4 sm:px-8">

        {/* Limited Offer Badge */}
        <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-[#FF3B30] rounded-full mb-4 sm:mb-6 animate-pulse">
          <i className="ri-time-line text-white text-xs sm:text-sm"></i>
          <span className="text-white text-[10px] sm:text-xs font-semibold uppercase tracking-wider">
            Oferta Limitada — Primeros 100
          </span>
        </div>

        {/* Countdown Timer */}
        <div className={`bg-gradient-to-r from-[#FF3B30] to-[#FF6B35] rounded-xl sm:rounded-2xl p-4 sm:p-6 mb-4 sm:mb-6 shadow-2xl ${isLastMinute ? 'animate-pulse' : ''}`}>
          <div className="flex items-center justify-center gap-2 mb-2 sm:mb-3">
            <i className="ri-alarm-warning-fill text-white text-base sm:text-xl"></i>
            <p className="text-white text-xs sm:text-sm font-semibold uppercase tracking-wide">
              ⚡ Esta oferta expira en:
            </p>
          </div>
          
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            {/* Hours */}
            <div className="bg-black/30 backdrop-blur-sm rounded-lg sm:rounded-xl px-2 sm:px-4 py-2 sm:py-3 min-w-[50px] sm:min-w-[70px]">
              <div className="text-3xl sm:text-4xl md:text-5xl font-black text-white leading-none">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <div className="text-white/70 text-[10px] sm:text-xs uppercase mt-1">Horas</div>
            </div>
            
            <span className="text-2xl sm:text-3xl font-bold text-white">:</span>
            
            {/* Minutes */}
            <div className="bg-black/30 backdrop-blur-sm rounded-lg sm:rounded-xl px-2 sm:px-4 py-2 sm:py-3 min-w-[50px] sm:min-w-[70px]">
              <div className="text-3xl sm:text-4xl md:text-5xl font-black text-white leading-none">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <div className="text-white/70 text-[10px] sm:text-xs uppercase mt-1">Min</div>
            </div>
            
            <span className="text-2xl sm:text-3xl font-bold text-white">:</span>
            
            {/* Seconds */}
            <div className="bg-black/30 backdrop-blur-sm rounded-lg sm:rounded-xl px-2 sm:px-4 py-2 sm:py-3 min-w-[50px] sm:min-w-[70px]">
              <div className="text-3xl sm:text-4xl md:text-5xl font-black text-white leading-none">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <div className="text-white/70 text-[10px] sm:text-xs uppercase mt-1">Seg</div>
            </div>
          </div>

          {/* Progress Bar */}
          <div className="space-y-2">
            <div className="flex items-center justify-between text-white text-[10px] sm:text-xs">
              <span className="font-semibold">Quedan {spotsLeft} de {totalSpots} accesos</span>
              <span className="font-bold">{progressPercentage.toFixed(0)}% vendido</span>
            </div>
            <div className="w-full bg-black/30 rounded-full h-2 overflow-hidden">
              <div 
                className="bg-white h-full rounded-full transition-all duration-500"
                style={{ width: `${progressPercentage}%` }}
              ></div>
            </div>
          </div>
        </div>

        {/* Main Title */}
        <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 sm:mb-8 leading-tight drop-shadow-lg">
          Acceso Anual por un<br />Precio Ridículo
        </h2>

        {/* Price Container */}
        <div className="bg-white rounded-2xl sm:rounded-3xl p-5 sm:p-6 md:p-10 shadow-2xl mb-6 sm:mb-8 mx-auto">
          <div className="flex items-start justify-center gap-1 mb-3 sm:mb-4">
            <span className="text-xl sm:text-2xl md:text-4xl text-[#666] font-normal mt-2 sm:mt-3 md:mt-4">S/</span>
            <span
              className="text-6xl sm:text-8xl md:text-[120px] font-black text-[#FF6B35] leading-none"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              25
            </span>
          </div>

          <p className="text-xs sm:text-sm md:text-lg text-[#999] mb-4 sm:mb-5">Soles Peruanos · Acceso por 1 Año</p>

          <div className="w-full h-px bg-[#E5E5E3] mb-4 sm:mb-5"></div>

          <div className="space-y-2 sm:space-y-3 text-left max-w-xs mx-auto">
            {[
              'Acceso Completo por 12 Meses',
              'Acceso Inmediato al Software',
              'Actualizaciones Durante el Año',
              '5 Bonos Exclusivos Incluidos'
            ].map((benefit, index) => (
              <div key={index} className="flex items-center gap-2 sm:gap-3">
                <i className="ri-checkbox-circle-fill text-[#00D9FF] text-base sm:text-lg flex-shrink-0"></i>
                <span className="text-xs sm:text-sm md:text-base text-[#0A0A0A] font-medium">{benefit}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center w-full px-0">
          <button
            onClick={handleComprar}
            className="group w-full sm:w-auto px-6 sm:px-8 md:px-14 py-4 sm:py-5 bg-[#0A0A0A] rounded-xl sm:rounded-2xl shadow-[0_12px_40px_rgba(255,107,53,0.45)] hover:bg-[#FF6B35] transition-all duration-300 cursor-pointer flex items-center justify-center gap-3 sm:gap-5 border-2 border-[#FF6B35] hover:border-[#FF6B35] hover:shadow-[0_16px_48px_rgba(255,107,53,0.65)] hover:scale-[1.02]"
          >
            <div className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 bg-[#FF6B35] group-hover:bg-white/20 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0 transition-colors">
              <i className="ri-shopping-cart-2-line text-white text-base sm:text-lg md:text-xl"></i>
            </div>
            <span className="text-white text-sm sm:text-base md:text-lg font-black uppercase tracking-widest leading-snug text-center">
              <span className="block sm:inline">Comenzar mi Año de Acceso</span>
              <span className="block sm:inline sm:before:content-['_—_']">S/ 25</span>
            </span>
            <div className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 bg-white/10 group-hover:bg-white/20 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0 transition-colors">
              <i className="ri-arrow-right-line text-white text-base sm:text-lg md:text-xl"></i>
            </div>
          </button>
        </div>

        {/* Security Badge */}
        <div className="mt-4 sm:mt-6 flex items-center justify-center gap-2 text-white/90">
          <i className="ri-lock-fill text-base sm:text-lg"></i>
          <span className="text-xs sm:text-sm font-light">Pago 100% Seguro y Garantizado</span>
        </div>

        {/* Guarantee note */}
        <p className="mt-2 sm:mt-3 text-white/60 text-[10px] sm:text-xs">
          Garantía de devolución de 7 días sin preguntas
        </p>
      </div>
    </section>
  );
}
